import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import appSettings from '../appSettings';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: appSettings.APPINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableAjaxTracking: true,
    disableFetchTracking:true,
    autoTrackPageVisitTime: true,
    //enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
  }
});
appInsights.loadAppInsights();

function logError(error, errorComponent, customProperties) {
  const errorMessage = error.message == null || error.message == undefined ? error : error.message;
  const errorStack = error.stack == null || error.stack == undefined ? error : error.stack;
               
  reactPlugin.trackException(
    { exception: error}, 
    {'am-message': errorMessage,
    'am-error': errorStack,
    'am-component': errorComponent,
    ...customProperties});
}

export { reactPlugin, appInsights, logError};